import { format } from 'date-fns';
import { useLayoutEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useDatePickerRangeState = (defaults?: {
  from?: Date;
  to?: Date;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultFrom = format(defaults?.from ?? Date.now(), 'yyyy-MM-dd');
  const defaultTo = format(defaults?.to ?? Date.now(), 'yyyy-MM-dd');
  const from = searchParams.get('from') || defaultFrom;
  const to = searchParams.get('to') || defaultTo;

  useLayoutEffect(() => {
    if (!searchParams.has('from') || !searchParams.has('to')) {
      setSearchParams({
        ...Object.fromEntries(searchParams.entries()),
        from: defaultFrom,
        to: defaultTo,
      });
    }
  }, [searchParams, setSearchParams, defaultFrom, defaultTo]);

  const setDateRange = (newDateRange: { from: string; to: string }) => {
    setSearchParams({
      ...Object.fromEntries(searchParams.entries()),
      from: newDateRange.from,
      to: newDateRange.to,
    });
  };

  return {
    from,
    to,
    setDateRange,
  };
};
